export enum ErrorSubscriberOrder {
    TARGETS = 1,
    TEMPLATE_SUBJECT = 2,
    NAME = 3,
    SHORTNAME = 4,
    SENDING_OPTIONS = 5,
    UTM = 6,
}

export type CampaignSummaryData = {
    alphabetSignature?: string;
    uniqueRecipients: number;
    uniqueRecipientsPercent: number;
    isWinner?: boolean;
};
export type CampaignSummaryType = {
    data: CampaignSummaryData[];
    isLoading: boolean;
};

export enum SplitOptimizationEnum {
    Opened = 'Opened',
    Clicked = 'Clicked',
}
